import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VoronoiEventsCount } from '../../models/voronoi-events-count';

@Injectable({
  providedIn: 'root'
})
export class VoronoiService {

  /** URL do endpoint de contagem de ocorrências por célula de voronoi */
  private voronoiEventsCountUrl = `${environment.serverBaseUrl}/voronoi/eventscount`;

  constructor(private http: HttpClient) { }

  /**
   * Faz requisição ao servidor para buscar a contagem de ocorrências por célula
   * de voronoi no intervalo de tempo especificado.
   * 
   * @param startDateTime data inicial no formato 'YYYY-MM-DD hh:mm'
   * @param endDateTime data final no formato 'YYYY-MM-DD hh:mm'
   * @param eventsTimeWindowInHours janela de tempo de ocorrências que 
   *    aconteceram depois do tempo inicial, em horas.
   */
  getEventsCountPerVoronoiCell(startDateTime: string, endDateTime: string) {

    return this.http.get<VoronoiEventsCount[]>(this.voronoiEventsCountUrl, { 
      params: { 
        startDateTime, endDateTime, }
    });
  }
}
